import { GeneralService } from './../../../../core/services/general.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../core/animations';
import { User } from '../../../../core/modelos/user';
import { UsuariosService } from '../usuarios.service';
import { Rol } from '../../../../core/modelos/rol';
import { Cliente } from '../../../../core/modelos/cliente';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';
import { ActivoOculto } from '../../../../core/modelos/activo_oculto';
import { ActivosOcultosService } from '../../../../core/services/activos-ocultos.service';

@Component({
    selector: 'fuse-usuarios-editar',
    templateUrl: './usuarios-editar.component.html',
    styleUrls: ['./usuarios-editar.component.scss'],
    animations: fuseAnimations
})
export class UsuariosEditarComponent implements OnInit {

    usuario: User;
    idUsuario: number;

    // Variable que indica si estamos editando o creando.
    editando = false;
    loading = true;

    // Validación del servidor
    validacion: any;

    // Formulario
    formulario: FormGroup;

    ocultar = true;

    selectedFiles: FileList;
    foto;

    roles: Array<Rol>;
    clientes: Array<Cliente>;
    activosOcultos: Array<ActivoOculto>;
    activosOcultosSelected: Array<ActivoOculto>;
    usuariosRestantes: number;



    constructor(
        private fb: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private usuariosService: UsuariosService,
        private generales: GeneralService,
        private activosOcultosService: ActivosOcultosService,
        private notificaciones: NotificacionesService
    ) {
        // Traigo el cliente por parametro
        this.activatedRoute.params.subscribe(params => {
            this.idUsuario = params['idUsuario'];
        });
    }

    ngOnInit() {

        this.init();
        this.getRoles();
        this.getClientes();
        if(this.idUsuario !== undefined) {
          this.getActivosOcultos(this.idUsuario);
        }

    }

    init() {

        if (this.idUsuario) {
            this.editando = true;
            this.getUsuario(this.idUsuario); // TODO: Suscribir para redirigir si no existe

        } else {
            // console.log('añadiendo...');
            this.loading = false;
            this.crearFormulario();
        }
    }

    getUsuario(id: number) {
        this.usuariosService.getUsuario(id).subscribe(
            data => {
                if (data.success) {
                    this.usuario = data.items;
                    this.usuario.foto = this.usuario.foto ? 'data:image/jpeg;base64,' + this.usuario.foto : this.usuario.foto;
                    this.loading = false;
                    this.crearFormulario();
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioNOObtenido);
                    this.router.navigate(['usuarios']);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    crearFormulario() {

        if (this.editando) {

            this.formulario = this.fb.group({
                nombre: [this.usuario.nombre, Validators.required],
                apellidos: [this.usuario.apellidos],
                email: [this.usuario.email, [Validators.required, Validators.email]],
                rol: [this.usuario.rol, Validators.required],
                cliente: [this.usuario.cliente], // Los adminBOD lo llevan a null
                activosOcultos: [this.activosOcultos],
            });
        }
        else {
            this.formulario = this.fb.group({
                nombre: ['', Validators.required],
                apellidos: [''],
                password: ['', Validators.required],
                email: ['', [Validators.required, Validators.email]],
                rol: ['', Validators.required],
                cliente: [''],
                activosOcultos: [''],
            });
        }

    }

    compare(val1, val2) {
        return val1.id === val2.id;
    }

    selectFile(event) {
        // Recoge la imagen que quiere subir el usuario y la guardo en this.foto con el formato adecuado
        this.selectedFiles = event.target.files;
        const reader = new FileReader();
        const file = this.selectedFiles.item(0);
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.foto = reader.result.split(',')[1];
            this.usuario.foto = 'data:image/jpeg;base64,' + this.foto; // Para que actualice en pantalla también
        };

    }

    onSubmit(): void {
        this.usuario = this.prepararModelo();
        // Hay que subirlo sin el 'data:image/jpeg;base64,'
        this.usuario.foto = this.foto;
        if (this.editando) {
            this.usuariosService.updateUsuario(this.usuario).subscribe(
                data => {
                    if (data.success) {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioEditado);
                        // this.init();
                        this.router.navigate(['usuarios']);
                    } else if (data.message) {
                        this.validacion = data.message;
                    }
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioNOEditado);
                        this.router.navigate(['usuarios']);
                        console.log('no data: 500');
                    }
                },
                err => {
                    if (err.error.message) {
                        this.validacion = err.error.message;
                    } else {
                        this.notificaciones.errorServidor(err.status);
                        // this.router.navigate(['usuarios']);
                    }
                }
            );
        } else {
            this.usuariosService.addUsuario(this.usuario).subscribe(
                data => {
                    if (data.success) {
                        // this.init();
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioCreado);
                        this.router.navigate(['usuarios']);
                    } else if (data.message) {
                        this.validacion = data.message;
                    }
                    else {
                        // this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioNOCreado);
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioNOCreado);
                        // this.router.navigate(['usuarios']);
                    }
                },
                err => {
                    if (err.error.message) {
                        this.validacion = err.error.message;
                    } else {
                        this.notificaciones.errorServidor(err.status);
                        this.router.navigate(['usuarios']);
                    }
                }
            );
        }
    }

    prepararModelo(): User {
        const formModel = this.formulario.value;

        const saveUser: User = {
            id: this.usuario ? this.usuario.id : undefined,
            nombre: formModel.nombre,
            apellidos: formModel.apellidos,
            email: formModel.email,
            password: !this.editando ? formModel.password : null,
            rol: formModel.rol,
            cliente: formModel.cliente,
            activosOcultos: formModel.activosOcultos
        };

        return saveUser;
    }
    getRoles() {
        this.usuariosService.getRoles().subscribe(
            data => {
                if (data.success) {
                    this.roles = data.items;
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.Roles.SinRoles);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }
    getClientes() {

        this.generales.getClientes().subscribe(
            data => {
                if (data.success) {
                    this.clientes = data.items;
                    // Si el usuario tiene más de 1 cliente (es adminBOD), se muestra select para que elija.
                    if (this.clientes.length > 1) {
                        this.ocultar = false;
                    }
                } else {
                    console.warn(data.message);
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.Clientes.NOObtenidos);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    getActivosOcultos(id) {

        this.activosOcultosService.getActivosOcultos(id).subscribe(
            data => {
                if (data.success) {
                    this.activosOcultos = data.items;
                    this.activosOcultosSelected = this.activosOcultos.filter(d => d.hidden);
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.ActivosOcultos.SinActivos);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );

    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/usuarios/editar/usuarios-editar.component.ts